import {
    useGetDMaxCommon,
    type AboutDmaxInfoResponse,
    type AroundDmaxInfoResponse,
    type MainInfoDmaxResponse,
} from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { AboutSection, BackBanner, ImgGallery, TopSection, Travel } from "../common";

export const About = () => {
    const { data: main } = useGetDMaxCommon<MainInfoDmaxResponse>({ section: "main" });
    const { data: about } = useGetDMaxCommon<AboutDmaxInfoResponse>({ section: "about" });
    const { data: around } = useGetDMaxCommon<AroundDmaxInfoResponse>({ section: "around" });
    return main && about && around ? (
        <>
            <TopSection sector={main.sector} imgList={main.imgList} />
            <AboutSection about={about} />
            <ImgGallery imgList={about.imgList} />
            <BackBanner imgUrl={main.imgList[0].img_URL} />
            {/* <Location /> */}
            {around.isUse && <Travel around={around} />}
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
